import React, { useEffect, useState } from "react";
import { Modal, Table, Tag, Button, Row, Skeleton } from "antd";
import GetMerchantSettleVatOut from "../../functions/merchant/getMerchantSettleVatOut";
import moneyFormat from "../../functions/utils/moneyFormat";
import { bg_text } from "constant/css";
import { getMerchantId } from "service/storage";

const MerchantVatOutDetail = ({ open, close }) => {
  const merchantSettleId = open;
  const merchantId = getMerchantId();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (merchantSettleId) fetchDetail();
    // eslint-disable-next-line
  }, [merchantSettleId]);

  const fetchDetail = async () => {
    setLoading(true);
    const response = await GetMerchantSettleVatOut(merchantId, merchantSettleId);
    if (response?.success) setData(response.data);
    else setData([]);
    setLoading(false);
  };

  const columns = [
    {
      title: "#",
      render: (_, __, index) => index + 1,
      width: 50,
      fixed: "left",
    },
    {
      title: "Дэд мерчант",
      dataIndex: "name",
      key: "name",
      width: 180,
    },
    {
      title: "Регистр",
      dataIndex: "register",
      key: "register",
      width: 120,
    },
    {
      title: "Гүйлгээ",
      dataIndex: "transactionCount",
      key: "transactionCount",
      width: 80,
      align: "right",
    },
    {
      title: "Мерчант шимтгэл",
      dataIndex: "merchantFee",
      key: "merchantFee",
      width: 120,
      align: "right",
      render: (e) => moneyFormat(e),
    },
    {
      title: "НӨАТ дүн",
      dataIndex: "vatAmount",
      key: "vatAmount",
      width: 120,
      align: "right",
      render: (e) => (
        <span className="text-orange-700 font-medium">{moneyFormat(e)}</span>
      ),
    },
  ];

  const totalMerchantFee = data.reduce(
    (sum, row) => sum + parseFloat(row.merchantFee || 0),
    0
  );
  const totalVatAmount = data.reduce(
    (sum, row) => sum + parseFloat(row.vatAmount || 0),
    0
  );

  return (
    <Modal
      title={
        <span className={`text-lg font-bold ${bg_text}`}>
          НӨАТ задаргаа — Settle #{merchantSettleId}
        </span>
      }
      open={open}
      width="80vw"
      style={{ top: 24, maxWidth: 1200 }}
      onCancel={close}
      footer={null}
      styles={{ body: { padding: "12px 16px" } }}
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 5 }} />
      ) : (
        <Table
          columns={columns}
          rowKey={(record) =>
            record.vatMerchantId ?? `unknown-${record.register}-${record.name}`
          }
          dataSource={data}
          scroll={{ x: "max-content", y: 360 }}
          size="small"
          pagination={false}
          summary={() => (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} />
                <Table.Summary.Cell index={1} colSpan={2}>
                  <span className="font-semibold">Нийт</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} align="right">
                  <span className="font-semibold">
                    {data.reduce((s, r) => s + (r.transactionCount || 0), 0)}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4} align="right">
                  <span className={`font-semibold ${bg_text}`}>
                    {moneyFormat(totalMerchantFee)}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5} align="right">
                  <span className="font-semibold text-orange-700">
                    {moneyFormat(totalVatAmount)}
                  </span>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
        />
      )}
    </Modal>
  );
};

export default MerchantVatOutDetail;
